import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm]       = useState({ username:'', password:'' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await api.post('/auth/login', form);
      login(data.token, data.user);
      navigate('/');
    } catch (err) {
      const status  = err.response?.status;
      const message = err.response?.data?.message;

      if (status === 401 || message === 'Invalid credentials') {
        setError('Incorrect username or password. Please try again.');
      } else if (status === 400) {
        setError('Please enter both username and password.');
      } else if (!err.response) {
        setError('Cannot connect to server. Make sure the backend is running.');
      } else {
        setError(message || 'Login failed. Please try again.');
      }
    } finally { setLoading(false); }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">
          <h1><i className="fa-solid fa-ticket"></i> TE Tracker</h1>
          <p>Support Ticket Management System</p>
        </div>

        {error && (
          <div className="alert alert-error" style={{display:'flex',alignItems:'flex-start',gap:8}}>
            <i className="fa-solid fa-circle-exclamation" style={{marginTop:1,flexShrink:0}}></i>
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="field" style={{marginBottom:14}}>
            <label>Username <span className="req">*</span></label>
            <input
              type="text"
              value={form.username}
              onChange={e => { setForm({...form, username: e.target.value}); setError(''); }}
              placeholder="Enter username"
              required
              autoFocus
              style={error ? {borderColor:'#e24b4a'} : {}}
            />
          </div>

          <div className="field" style={{marginBottom:24}}>
            <label>Password <span className="req">*</span></label>
            <div style={{position:'relative'}}>
              <input
                type={showPwd ? 'text' : 'password'}
                value={form.password}
                onChange={e => { setForm({...form, password: e.target.value}); setError(''); }}
                placeholder="Enter password"
                required
                style={{
                  width:'100%', paddingRight:36,
                  ...(error ? {borderColor:'#e24b4a'} : {})
                }}
              />
              <span
                onClick={() => setShowPwd(s => !s)}
                style={{
                  position:'absolute', right:10, top:'50%', transform:'translateY(-50%)',
                  cursor:'pointer', color:'#aaa', fontSize:14
                }}>
                <i className={`fa-solid ${showPwd ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </span>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{width:'100%', justifyContent:'center', padding:'10px'}}
            disabled={loading}>
            {loading
              ? <><i className="fa-solid fa-spinner fa-spin"></i> Signing in...</>
              : <><i className="fa-solid fa-right-to-bracket"></i> Sign In</>}
          </button>
        </form>
      </div>
    </div>
  );
}